import SettingsComment from "./SettingsComment";

export default SettingsComment